import {
  all,
  fork,
  takeEvery,
  takeLatest,
  put,
  select,
} from "redux-saga/effects";
import { slotsApi, authApi } from "../../api";
import { SlotsActionTypes, AuthActionTypes } from "../actions";
import { Cookies, Utils, SessionStorage } from "../../helpers";
import moment from "moment";

export function* requests() {
  function* refreshToken() {
    try {
      window.log("!slot saga ");
      const expTokenDateTime = Cookies.get("expTokenDateTime");
      const refreshToken = Cookies.get("refreshToken");
      const { app } = yield select();
      const { serverTime } = app;
      // console.log("!expTokenDateTime", expTokenDateTime)
      window.log("!moment(serverTime)", Utils.formatDate(serverTime));
      window.log("!expTokenDateTime raw value:", expTokenDateTime);
      window.log("!expTokenDateTime type:", typeof expTokenDateTime);
      window.log(
        "!moment(expTokenDateTime",
        Utils.formatDate(expTokenDateTime)
      );

      // Check if expTokenDateTime is valid
      const expTokenMoment = moment(expTokenDateTime);
      const isExpTokenValid = expTokenMoment.isValid();
      const expTokenUtc = moment(expTokenDateTime).utc();
      const serverTimeUtc =  moment(serverTime).utc();
      
      console.log("serverTimeUtc.isAfter(expTokenUtc)", serverTimeUtc.isAfter(expTokenUtc));
      if (
        (refreshToken &&
          isExpTokenValid &&
        serverTimeUtc.isAfter(expTokenUtc)) ||
        (refreshToken && (!expTokenDateTime || !isExpTokenValid))
      ) {
        window.log("!slots need to refreshToken ");
        console.log("!refreshToken exists:", !!refreshToken);
        console.log("!expTokenDateTime exists:", !!expTokenDateTime);
        console.log("!isExpTokenValid:", isExpTokenValid);
        console.log(
          "!serverTime > expToken:",
          isExpTokenValid ? moment(serverTime) > expTokenMoment : "N/A"
        );

        let data = { refreshToken: refreshToken };
        let response = yield authApi.refreshToken(data);
        switch (response.status) {
          case 1:
            window.log("!refreshToken result", response);
            const tokenExpiresMinutes = response.data.tokenExpiresMinutes;
            yield put({ type: AuthActionTypes.Refresh_Token_Success });
            Cookies.set("token", response.data.token, tokenExpiresMinutes);
            Cookies.set(
              "expTokenDateTime",
              response.data.expDateTime,
              tokenExpiresMinutes
            );
            Cookies.set("refreshToken", response.data.refreshToken, tokenExpiresMinutes);
            Cookies.set(
              "tokenExpiresMinutes",
              response.data.tokenExpiresMinutes
            );
            break;
          case 3 || 4:
            put({
              type: AuthActionTypes.Refresh_Token_Error,
              message: response.message,
            });
            yield put({ type: AuthActionTypes.Signout_Request });
            window.log("token error signout", response.message);
            break;
          default:
            break;
        }
      } else {
        window.log("!no need to refreshToken");
      }
    } catch (error) {
      window.log("client =>> could not create bet code: ", error);
    }
  }

  yield takeEvery(SlotsActionTypes.Get_Slots_Games_Request, function* ({
    templateId,
  }) {
    //call server
    try {
      
      yield refreshToken();
      let response = yield slotsApi.getSlotsGames(templateId);

      switch (response.status) {
        case 1:
          let tabs = [
            {
              categoryId: 0,
              categoryName: "All",
              categoryOrder: 0,
              id: 0,
            },
          ];
          response.data.slotsGamesCategories.map((item, i) => {
            let result = response.data.slotsGames.find(
              (game) => game.categoryId === item.categoryId
            );
            if (result) {
              tabs.push(item);
            }
          });
          yield put({
            type: SlotsActionTypes.Get_Slots_Games_Success,
            slotsGames: response.data.slotsGames,
            categories: tabs,
            config: response.data.slotsGamesConfiguration,
            slotsFrontPageTemplates: response.data.slotsFrontPageTemplates,
            slotsGamesCategories: response.data.slotsGamesCategories,
          });

          break;
        case 3 || 4:
          yield put({
            type: SlotsActionTypes.Get_Slots_Games_Error,
            message: response.message,
          });
          break;
        default:
          yield put({
            type: SlotsActionTypes.Get_Slots_Games_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get slots: ", error);
    }
  });

  yield takeEvery(SlotsActionTypes.Slots_Game_Connect_Request, function* ({
    request,
  }) {
    //call server
    try {
      yield refreshToken();

      let response = yield slotsApi.slotsConnect(request);

      switch (response.status) {
        case 1:
          yield put({
            type: SlotsActionTypes.Slots_Game_Connect_Success,
            token: response.data.slotsToken,
            currentGame: response.data.gameName,
            gameSymbols: response.data.slotGameSymbols,
            partner: response.data.partner,
            iframeUrl: response.data.iframeUrl,
            gameTypeId: response.data.gameTypeId,
            platformGameName: response.data.platformGameName,
          });

          break;
        case 3 || 4:
          yield put({
            type: SlotsActionTypes.Slots_Game_Connect_Error,
            message: response.message,
          });
          break;
        default:
          yield put({
            type: SlotsActionTypes.Slots_Game_Connect_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not connect slots: ", error);
    }
  });

  yield takeEvery(
    SlotsActionTypes.Get_Slots_Bonus_Games_By_Condition_Id_Request,
    function* ({ data }) {
      //call server
      try {
        yield refreshToken();
        let response = yield slotsApi.getSlotsBonusGamesByConditionId(data);

        switch (response.status) {
          case 1:
            yield put({
              type:
                SlotsActionTypes.Get_Slots_Bonus_Games_By_Condition_Id_Success,
              slotBonusGame: response.data,
            });

            break;
          case 3 || 4:
            yield put({
              type:
                SlotsActionTypes.Get_Slots_Bonus_Games_By_Condition_Id_Error,
              slotBonusGameError: response.message,
            });
            break;
          default:
            yield put({
              type:
                SlotsActionTypes.Get_Slots_Bonus_Games_By_Condition_Id_Error,
              slotBonusGameError: response.message,
            });
            break;
        }
      } catch (error) {
        window.log("client =>> could not connect slots: ", error);
      }
    }
  );
}

export default function* TransactionsSaga() {
  yield all([fork(requests)]);
}
